import styles from './styles.module.css';
import { ICONS, Icon } from '@/modules/ui-elements/Icon';
import UploadFilePopup from './UploadFilePopup';
import { useRef, useState, useEffect } from 'react';
import { ListData, listingStaticData } from '@/modules/marketplaceListing/constants';
import ExistingProjectsListPopup from './ExistingProjectsListPopup';
import useAuth from '@/hooks/useAuth';
import { useSelector } from 'react-redux';
import { useAtomValue, useSetAtom, useAtom } from 'jotai';
import { createAnotherListingPopupAtom, imagesDataAtom, selectedImageDataAtom, triggerAutoCsvDownloadWhenLoggedInAtom, triggerAutoPackageSubmissionWhenLoggedInAtom, openFileUploaderAtom, imagesForLoadingAtom } from '@/modules/marketplaceListing/Atoms';
import { TrackWebappEvent } from "@/modules/segment-event-tracking/segmentEventTracking";
import { segmentEventPayload, showLoginPopupAtom } from "@/modules/editor-v2/Atoms";
import { EventTrackName } from '@/modules/segment-event-tracking/constant';
import useResetAll from '@/modules/marketplaceListing/useReset';
import Image from 'next/legacy/image';
import { Dialog, DialogContent, DialogTitle, Skeleton } from '@mui/material';
import { Box } from '@mui/system';
import { useSearchParams } from "next/navigation";
import { useRouter } from 'next/router';

export default function MarketplaceListing() {
    // ATOM VALUES
    const isCreateAnotherListing = useAtomValue(createAnotherListingPopupAtom);
    const getSegmentPayloadAtom = useAtomValue(segmentEventPayload);
    const images = useAtomValue(imagesDataAtom);
    const selectedImage = useAtomValue(selectedImageDataAtom);
    const [openFileUploader, setOpenFileUploader] = useAtom(openFileUploaderAtom);

    // STATES
    const [openExistingProjects, setOpenExistingProjects] = useState(false)
    const [isVideoDialogOpen, setIsVideoDialogOpen] = useState(false);

    // CUSTOM HOOKS
    const { user } = useAuth();
    const { resetStates } = useResetAll();
    const router = useRouter();

    // SET ATOM VALUES
    const setTriggerForAutoCsvDownload = useSetAtom(triggerAutoCsvDownloadWhenLoggedInAtom)
    const setTriggerForAutoPackageSubmission = useSetAtom(triggerAutoPackageSubmissionWhenLoggedInAtom)
    const setLogoClick = useSetAtom(showLoginPopupAtom);
    const setImagesForLoading = useSetAtom<any>(imagesForLoadingAtom);

    // REDUX
    const { entireStrapiData } = useSelector((state: any) => state.strapi);
    const webListingScreen = entireStrapiData?.WebListingScreen;

    // REF

    const onclickingInstantListing = () => {
        const newQuery = { ...router.query };
        delete newQuery?.toolType;
        router.replace({ pathname: router.pathname, query: newQuery }, undefined, { shallow: true })
        resetStates();
        setTriggerForAutoCsvDownload(false);
        setTriggerForAutoPackageSubmission(false);
        setLogoClick(false);
        setOpenFileUploader(true);
        setImagesForLoading(null);
        TrackWebappEvent(`${process.env.NEXT_PUBLIC_EVENT_TRACK_TYPE}${EventTrackName._get_started_listing_hp}`, {
            ...getSegmentPayloadAtom,
            marketplace_name: 'Amazon',
        });
    }

    const handleUploadExistingProject = () => {
        TrackWebappEvent(`${process.env.NEXT_PUBLIC_EVENT_TRACK_TYPE}${EventTrackName._click_existing_project_list}`, {
            ...getSegmentPayloadAtom,
            marketplace_name: 'Amazon',
        });
        setOpenFileUploader(false);
        setOpenExistingProjects(true)
    }

    const onExistingProjectBack = () => {
        setOpenFileUploader(true);
        setOpenExistingProjects(false);
    }

    const videoUrl = webListingScreen?.HomeHeroSectionVideoLink || "https://dresma-assets.s3.us-east-2.amazonaws.com/DoMyShoot/App+Screens/amazon+listing_final.mp4";
    const videoPlayerHandler = () => {
        setIsVideoDialogOpen(true);
        TrackWebappEvent(`${process.env.NEXT_PUBLIC_EVENT_TRACK_TYPE}${EventTrackName._Click_Video_Amazon_Listing}`, {
            clicked_on: "amazon listing homepage video thumbnail"
        });
    }

    const searchParams = useSearchParams();
    const toolType = searchParams.get('toolType');

    useEffect(() =>{
        if(Object.keys(getSegmentPayloadAtom || {}).length && toolType){
        {
            if(toolType == "AmazonListing"){
                onclickingInstantListing();
            }
        }
    }
    },[searchParams,getSegmentPayloadAtom])

    return (
        <>
            <UploadFilePopup
                webListingScreen={webListingScreen}
                title={webListingScreen?.ListingModalTitle || listingStaticData?.createStandoutListing}
                openFileUploader={openFileUploader || isCreateAnotherListing}
                setOpenFileUploader={setOpenFileUploader}
                handleUploadExistingProject={handleUploadExistingProject}
                hideExistingProjects={user?.user?.login_type !== "Guest" ? false : true}
                multiple={true}
            />
            <ExistingProjectsListPopup
                webListingScreen={webListingScreen}
                openExistingProjects={openExistingProjects}
                backHandler={onExistingProjectBack}
            />
        </>
    )
};
